module.exports = __webpack_public_path__ + "static/media/3.503c925b.JPG";